export default __webpack_public_path__ + "static/media/personal-identified.948ba707.png";